import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
import { CurrentClinicUnitFragmentDoc, ClinicUnitFragmentDoc } from '../clinic/document.gen';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCurrentAccountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchCurrentAccountQuery = { __typename?: 'Query', currentAccount: { __typename?: 'DoctorAccount', id: string, email: string | null, currentRole: Types.Role | null, doctors: Array<{ __typename?: 'Doctor', id: string, profile: { __typename?: 'DoctorProfile', firstname: string | null, lastname: string | null, avatar: string | null } | null }>, currentClinic: { __typename?: 'Clinic', curonClinicId: string, clinicCode: string | null, auPharmacyPocEnabled: boolean, quickPassAvailable: boolean, receptionStatus: Types.ReceptionStatus, receptionAvailable: boolean, receptionAccessAvailable: boolean, receptionShowOutings: boolean, fastPassReceptionStatus: Types.FastPassReceptionStatus, fastPassReceptionAccessAvailable: boolean, idCardRequired: boolean, checkInPaused: boolean, remoteCheckInSuspended: boolean, notAcceptInsuranceCard: boolean, receptionSettingCompleted: boolean, neverUsedReception: boolean, id: string, name: string, receptionSetting: { __typename?: 'ReceptionSetting', id: string } | null }, preference: { __typename?: 'DoctorPreference', checkInNotificationEnabled: boolean }, webPushSubscriptions: Array<{ __typename?: 'WebPushSubscription', id: string }> | null, clinics: Array<{ __typename?: 'Clinic', id: string, name: string }>, loginLog: { __typename?: 'LoginLog', firstLoggedInAt: string, lastLoggedInAt: string } | null } | null };

export type DoctorAccountUnitFragment = { __typename?: 'DoctorAccount', id: string, email: string | null, currentRole: Types.Role | null, doctors: Array<{ __typename?: 'Doctor', id: string, profile: { __typename?: 'DoctorProfile', firstname: string | null, lastname: string | null, avatar: string | null } | null }>, currentClinic: { __typename?: 'Clinic', curonClinicId: string, clinicCode: string | null, auPharmacyPocEnabled: boolean, quickPassAvailable: boolean, receptionStatus: Types.ReceptionStatus, receptionAvailable: boolean, receptionAccessAvailable: boolean, receptionShowOutings: boolean, fastPassReceptionStatus: Types.FastPassReceptionStatus, fastPassReceptionAccessAvailable: boolean, idCardRequired: boolean, checkInPaused: boolean, remoteCheckInSuspended: boolean, notAcceptInsuranceCard: boolean, receptionSettingCompleted: boolean, neverUsedReception: boolean, id: string, name: string, receptionSetting: { __typename?: 'ReceptionSetting', id: string } | null }, preference: { __typename?: 'DoctorPreference', checkInNotificationEnabled: boolean }, webPushSubscriptions: Array<{ __typename?: 'WebPushSubscription', id: string }> | null, clinics: Array<{ __typename?: 'Clinic', id: string, name: string }>, loginLog: { __typename?: 'LoginLog', firstLoggedInAt: string, lastLoggedInAt: string } | null };

export type DoctorProfileUnitFragment = { __typename?: 'DoctorProfile', firstname: string | null, lastname: string | null, avatar: string | null };

export type FetchCurrentClinicExistsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchCurrentClinicExistsQuery = { __typename?: 'Query', currentClinicExists: boolean, currentAccount: { __typename?: 'DoctorAccount', id: string, clinics: Array<{ __typename?: 'Clinic', id: string, name: string }> } | null };

export const DoctorProfileUnitFragmentDoc = gql`
    fragment DoctorProfileUnit on DoctorProfile {
  firstname
  lastname
  avatar
}
    `;
export const DoctorAccountUnitFragmentDoc = gql`
    fragment DoctorAccountUnit on DoctorAccount {
  id
  email
  doctors {
    id
    profile {
      ...DoctorProfileUnit
    }
  }
  currentClinic {
    ...CurrentClinicUnit
  }
  currentRole
  preference {
    checkInNotificationEnabled
  }
  webPushSubscriptions {
    id
  }
  clinics {
    ...ClinicUnit
  }
  loginLog {
    firstLoggedInAt
    lastLoggedInAt
  }
}
    ${DoctorProfileUnitFragmentDoc}
${CurrentClinicUnitFragmentDoc}
${ClinicUnitFragmentDoc}`;
export const FetchCurrentAccountDocument = gql`
    query FetchCurrentAccount {
  currentAccount {
    ...DoctorAccountUnit
  }
}
    ${DoctorAccountUnitFragmentDoc}`;

/**
 * __useFetchCurrentAccountQuery__
 *
 * To run a query within a React component, call `useFetchCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables>(FetchCurrentAccountDocument, options);
      }
export function useFetchCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables>(FetchCurrentAccountDocument, options);
        }
export type FetchCurrentAccountQueryHookResult = ReturnType<typeof useFetchCurrentAccountQuery>;
export type FetchCurrentAccountLazyQueryHookResult = ReturnType<typeof useFetchCurrentAccountLazyQuery>;
export type FetchCurrentAccountQueryResult = Apollo.QueryResult<FetchCurrentAccountQuery, FetchCurrentAccountQueryVariables>;
export const FetchCurrentClinicExistsDocument = gql`
    query FetchCurrentClinicExists {
  currentClinicExists
  currentAccount {
    id
    clinics {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchCurrentClinicExistsQuery__
 *
 * To run a query within a React component, call `useFetchCurrentClinicExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentClinicExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentClinicExistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentClinicExistsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentClinicExistsQuery, FetchCurrentClinicExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentClinicExistsQuery, FetchCurrentClinicExistsQueryVariables>(FetchCurrentClinicExistsDocument, options);
      }
export function useFetchCurrentClinicExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentClinicExistsQuery, FetchCurrentClinicExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentClinicExistsQuery, FetchCurrentClinicExistsQueryVariables>(FetchCurrentClinicExistsDocument, options);
        }
export type FetchCurrentClinicExistsQueryHookResult = ReturnType<typeof useFetchCurrentClinicExistsQuery>;
export type FetchCurrentClinicExistsLazyQueryHookResult = ReturnType<typeof useFetchCurrentClinicExistsLazyQuery>;
export type FetchCurrentClinicExistsQueryResult = Apollo.QueryResult<FetchCurrentClinicExistsQuery, FetchCurrentClinicExistsQueryVariables>;